import { apiGet, apiPost } from './api';

interface VapidKeyResp { publicKey: string }

interface SubscribePayload {
  userNum?: number | null;
  charIdx?: number | null;
  kind: number;                       // 0=player, 1=gm
  userAgent?: string;
  subscription: PushSubscriptionJSON;
}

export const getVapidPublicKey = () => apiGet<VapidKeyResp>('/push/vapidKey');
export const pushSubscribe     = (p: SubscribePayload) => apiPost<{ ok: boolean }>('/push/subscribe', p);
export const pushUnsubscribe   = (endpoint: string) => apiPost<{ ok: boolean }>('/push/unsubscribe', { endpoint });
